(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bmh-combined-loox-rating"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    if (event.defaultPrevented || !(event.target instanceof Element)) return;
    const trigger = event.target.closest('[data-bmh-combo-reviews]');
    if (!trigger || typeof window.LOOX?.openHCFloater !== 'function') return;
    event.preventDefault();
    window.LOOX.openHCFloater(trigger.dataset.bmhComboReviews);
  });
  } catch(e) { console.error(e); }
})();

})();
